import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_AppErrorField = _resolveComponent("AppErrorField")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_form = _resolveComponent("el-form")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _cache[5] || (_cache[5] = _createElementVNode("h4", null, " Please enter the verification code sent to your email adress below, your email adress and a new password ", -1)),
    _cache[6] || (_cache[6] = _createElementVNode("br", null, null, -1)),
    _createVNode(_component_el_form, {
      ref: "formRef",
      model: _ctx.form,
      rules: _ctx.rules
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_form_item, { prop: "code" }, {
          default: _withCtx(() => [
            _createVNode(_component_el_input, {
              modelValue: _ctx.form.code,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.form.code) = $event)),
              placeholder: "Verification code"
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, { prop: "email" }, {
          default: _withCtx(() => [
            _createVNode(_component_el_input, {
              modelValue: _ctx.form.email,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.form.email) = $event)),
              placeholder: "Email",
              readonly: "",
              "prefix-icon": _ctx.Message
            }, null, 8, ["modelValue", "prefix-icon"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, { prop: "password" }, {
          default: _withCtx(() => [
            _createVNode(_component_el_input, {
              modelValue: _ctx.form.newPassword,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.form.newPassword) = $event)),
              type: "password",
              placeholder: "New Password",
              "prefix-icon": _ctx.Lock
            }, null, 8, ["modelValue", "prefix-icon"])
          ]),
          _: 1
        }),
        _createVNode(_component_AppErrorField, { error: _ctx.errorMsg }, null, 8, ["error"]),
        _cache[4] || (_cache[4] = _createElementVNode("br", null, null, -1)),
        _createVNode(_component_el_form_item, null, {
          default: _withCtx(() => [
            _createVNode(_component_el_button, {
              class: "w-100",
              type: "primary",
              onClick: _ctx.changePassword
            }, {
              default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
                _createTextVNode(" CHANGE PASSWORD ", -1)
              ]))]),
              _: 1
            }, 8, ["onClick"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["model", "rules"])
  ], 64))
}